import React from 'react';
import { Badge, Box, Container, Heading, Text, VStack } from '@chakra-ui/react';

const ACCENT = '#ffcc00';
const SECONDARY = '#3eb297';

export const CilPointsHero = ({ badge, title, subtitle }) => (
  <Box
    position="relative"
    w="100%"
    h={{ base: '360px', md: '440px' }}
    overflow="hidden"
    backgroundImage="linear-gradient(135deg, rgba(255, 204, 0, 0.85) 0%, rgba(62, 178, 151, 0.85) 100%)"
    backgroundSize="cover"
    backgroundPosition="center"
  >
    <Box position="absolute" inset={0} bg="rgba(0, 0, 0, 0.45)" />
    <Container
      maxW="container.lg"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      position="relative"
      zIndex={1}
      color="white"
      textAlign="center"
      px={4}
    >
      <VStack spacing={6}>
        <Badge
          bg={ACCENT}
          color="black"
          px={4}
          py={2}
          borderRadius="full"
          fontSize="sm"
          fontWeight="600"
        >
          {badge}
        </Badge>
        <Heading
          as="h1"
          fontSize={{ base: '2xl', md: '4xl' }}
          fontWeight="800"
          lineHeight="shorter"
          maxW="3xl"
        >
          {title}
        </Heading>
        <Text fontSize={{ base: 'md', md: 'lg' }} maxW="2xl" opacity={0.95}>
          {subtitle}
        </Text>
      </VStack>
    </Container>
  </Box>
);

export const CilPointsSection = ({ badge, title, children, id }) => (
  <VStack
    id={id}
    spacing={4}
    textAlign="center"
    w="full"
    align="center"
    scrollMarginTop="80px"
  >
    <Badge
      bg={ACCENT}
      color="black"
      px={4}
      py={2}
      borderRadius="full"
      fontSize="sm"
      fontWeight="600"
    >
      {badge}
    </Badge>
    <Heading
      as="h2"
      size={{ base: 'lg', md: 'xl' }}
      color="white"
      fontWeight="800"
    >
      {title}
    </Heading>
    <Box maxW="3xl" w="full" textAlign="left">
      {children}
    </Box>
  </VStack>
);

export const CilPointsStepCard = ({
  step,
  title,
  description,
  accent = ACCENT,
}) => (
  <Box
    bg="#2f3136"
    border="2px solid"
    borderColor={accent}
    borderRadius="12px"
    p={6}
    h="full"
    transition="all 0.3s ease"
    _hover={{
      transform: 'translateY(-4px)',
      boxShadow: `0 8px 25px ${accent === ACCENT ? 'rgba(255, 204, 0, 0.25)' : 'rgba(62, 178, 151, 0.25)'}`,
    }}
  >
    <Badge
      bg={accent}
      color="black"
      mb={3}
      borderRadius="full"
      fontWeight="700"
    >
      {step}
    </Badge>
    <Heading as="h3" size="md" color="white" mb={2}>
      {title}
    </Heading>
    <Text color="gray.300" fontSize="sm" lineHeight="tall">
      {description}
    </Text>
  </Box>
);

export const CIL_POINTS_LANDING_ACCENTS = { ACCENT, SECONDARY };
